import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import ShowMoreText from '../../common/ShowMoreText';
const ItemHeadline = ({ size, showTitle, headline, description, isShowMore, maxLines, }) => (_jsxs(Box, { children: [showTitle && (_jsx(Typography, { variant: "h5", fontWeight: "fontWeightBold", className: "courseHeadline", sx: {
                mb: 1,
            }, children: headline })), isShowMore ? (_jsx(ShowMoreText, { text: description })) : (_jsx(Typography, { variant: "body1", className: "description", sx: size === 'medium' ? {
                display: '-webkit-box',
                WebkitLineClamp: (maxLines || 2),
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                height: `${(maxLines && 1.5 * maxLines) || 3}em`,
                marginTop: 0,
            } : {
                display: '-webkit-box',
                WebkitLineClamp: (maxLines || 4),
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                height: `${(maxLines && 1.5 * maxLines) || 6}em`,
            }, children: description }))] }));
ItemHeadline.defaultProps = {
    showTitle: true,
};
export default ItemHeadline;
//# sourceMappingURL=ItemHeadline.js.map